module.exports = __webpack_public_path__ + "media/images/mobile-only/mobile-only-3-6ba6f019a9fe902c662b8a70c93bdcd9.png";